// __JOB_ORDER__ (2026-10-27) each driver's jobs in ONE order, top first - the same on Trello (his driver list), here
// (Planning -> Drivers, Route Builder) and in the Driver app. The hub keeps it (Billing-Manager job_order.py, app_config
// 'driver_job_order') and mirrors it with Trello; this board reads it (GET /api/board/planning/job-order) and sends a
// reorder (POST, services/hubPlanning.js saveJobOrder). Pure helpers: sim/joborder.test.mjs.

// The order doc as the hub sends it: { drivers: { driverId: { ids: [load ids, top first], at, src } }, routes: {...} }
export const idsOf = (doc, driverId) => {
  const r = doc && doc.drivers && driverId ? doc.drivers[driverId] : null;
  return (r && Array.isArray(r.ids)) ? r.ids.map(String) : [];
};

export const indexMap = (doc, driverId) => {
  const m = new Map();
  idsOf(doc, driverId).forEach((id, i) => { if (!m.has(id)) m.set(id, i); });
  return m;
};

// A job's place in its driver's order (Infinity: not ordered yet).
export const rankOf = (doc, driverId, id) => {
  const m = indexMap(doc, driverId);
  return m.has(String(id)) ? m.get(String(id)) : Infinity;
};

// One driver's items in his order: the ordered ones by their place, the others after them as they were.
export const sortForDriver = (items, getId, doc, driverId) => {
  const m = indexMap(doc, driverId);
  return (items || []).map((x, i) => [x, i]).sort((a, b) => {
    const ia = m.has(String(getId(a[0]))) ? m.get(String(getId(a[0]))) : Infinity;
    const ib = m.has(String(getId(b[0]))) ? m.get(String(getId(b[0]))) : Infinity;
    if (ia !== ib) return ia === Infinity ? 1 : (ib === Infinity ? -1 : ia - ib);
    return a[1] - b[1];
  }).map((p) => p[0]);
};

// A mixed list (jobs of several drivers, e.g. Route Builder's job list): each driver's jobs are put in his order in
// the places his jobs already hold; unassigned jobs stay where they are.
export const refillByDriver = (ids, driverOf, doc) => {
  const out = (ids || []).slice();
  const slots = {};
  out.forEach((id, i) => { const d = driverOf(id); if (d) (slots[d] = slots[d] || []).push(i); });
  Object.keys(slots).forEach((d) => {
    const mine = slots[d].map((i) => out[i]);
    const sorted = sortForDriver(mine, (x) => x, doc, d);
    slots[d].forEach((slot, k) => { out[slot] = sorted[k]; });
  });
  return out;
};

// The hub's merge (job_order.merge): the given jobs in the given order, in the places they held; others stay.
export const mergeOrder = (stored, given) => {
  const st = [];
  (stored || []).forEach((x) => { const s = String(x); if (s && !st.includes(s)) st.push(s); });
  const g = [];
  (given || []).forEach((x) => { const s = String(x); if (s && !g.includes(s)) g.push(s); });
  if (!g.length) return st;
  const base = st.concat(g.filter((x) => !st.includes(x)));
  const gs = new Set(g);
  const out = base.slice();
  let k = 0;
  base.forEach((x, i) => { if (gs.has(x)) { out[i] = g[k]; k += 1; } });
  return out;
};

// The doc with one driver's order changed here (shown at once, before the hub answers).
export const withDriverOrder = (doc, driverId, given) => {
  const drivers = { ...((doc && doc.drivers) || {}) };
  drivers[driverId] = { ...(drivers[driverId] || {}), ids: mergeOrder(idsOf(doc, driverId), given), src: 'hauling' };
  return { ...(doc || {}), drivers };
};

// Move one id onto another's place (the one it was dropped on), or to the end (overId null).
export const moveId = (ids, activeId, overId) => {
  const out = (ids || []).filter((x) => x !== activeId);
  const to = overId == null ? out.length : (ids || []).indexOf(overId);
  if (to < 0 || (ids || []).indexOf(activeId) < 0) return (ids || []).slice();
  out.splice(Math.min(to, out.length), 0, activeId);
  return out;
};

export const insertId = (ids, id, index) => {
  const out = (ids || []).filter((x) => x !== id);
  out.splice(Math.max(0, Math.min(index == null ? out.length : index, out.length)), 0, id);
  return out;
};
